import { Injectable } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Injectable({
    providedIn: 'root'
})
export class CellRenderingService extends DataService {

    getIsValidDisplay(params: any) {
        const value = params.value;
        const data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
        if (data.iFFDelinquentEmailsID != null && Number(data.iFFDelinquentEmailsID) > 0
        && (value === 'Pending' || value === 'Rejected')) {
          const checkField = params.colDef.field;
          const reportQTR = data.iFFReportingQTR;
          if (checkField.indexOf(reportQTR) >= 0) {
            return true;
          } else {
              return false;
          }
        } else {
            return false;
        }
    }
}
